/*
  Berechnete Warenkorbzeilen: Erkennung, Gruppen und Kundeneinheit.

  Reine Funktionen ohne DOM. Dieselbe Datei laeuft im Shop
  (assets/component-cart-items.js) und in den Tests
  (qa/tests/cart-gruppen.test.mjs). Die Server-Seite ist
  snippets/tp-cart-gruppe.liquid - beide setzen dieselben Regeln um; die
  Tests hier pruefen den JS-Teil, der Liquid-Teil wird per Grep auf die
  gleichen Property-Namen geprueft.

  Eine Zeile ist "berechnet", wenn Rollenrechner oder Einfass-Konfigurator
  sie erzeugt haben - ihre Menge ergibt sich aus Massen, nicht aus einer
  Stueckzahl. Erkannt wird das datengetrieben, nie ueber Handles:
    (a) Property _Gruppe vorhanden
    (b) Property Art mit Wert Meterware oder Raummass
    (c) Produkt-Metafeld custom.preis_pro_001_qm == true
    (d) Property "Zu Teppich"/"Zu Teppichboden"/"Zu Bodenbelag" oder "Kante umlaufend"
        (Service-Zeile: Kettelservice, Fussleiste, Haftunterlage) - oder
        Produkttyp "Service" (so tragen Kettelservice und Fussleiste ihn im
        Shop; eine Service-Zeile ohne Properties kam ohne Rechner herein)
    (e) Optionswert "Wunschmass" (Raummass-Variante)

  Laengenware (Produkt-Metafeld custom.preis_pro_001_lfm, Profile nach Mass,
  Menge = Laenge je Stueck x Stueckzahl in cm) ist ueber ihre _Gruppe
  berechnet; Liquid-Seite dazu: snippets/tp-cart-laengenware.liquid.

  Fail safe: Eine Zeile, die ohne Rechner in den Warenkorb kam (Service ohne
  Gruppe, Flaechenware ohne Mass, Laengenware ohne "Länge je Stück", Gruppe
  ohne Hauptzeile), sperrt den Checkout, statt still zum Variantenpreis
  durchzulaufen.

  Eingabeformat einer Zeile (aus /cart.js oder aus Liquid-Attributen):
    { key, quantity, properties: {..}, preisPro001Qm: bool, preisPro001Lfm: bool, optionen: [..], typ, titel }
*/
(function (root) {
  'use strict';

  var ART_WERTE = /^(meterware|raumma(ß|ss))$/i;
  var WUNSCH = /^wunschma(ß|ss)$/i;
  var FLAECHE_KEYS = ['Fläche (abgerechnet)', 'Fläche', 'Fläche (aufgerundet)', 'Fläche (berechnet)'];
  var MASS_KEYS = FLAECHE_KEYS.concat(['Ihre Breite', 'Rollenbreite', 'Breite', 'Maße']);
  var SERVICE_KEYS = ['Zu Teppich', 'Zu Teppichboden', 'Zu Bodenbelag'];
  var SERVICE_TYP = /^service$/i;

  var GRUND = {
    GRUPPE_OHNE_HAUPT: 'gruppe-ohne-haupt',
    OHNE_MASS: 'ohne-mass',
    SERVICE_OHNE_GRUPPE: 'service-ohne-gruppe',
    ZUSCHNITT_FEHLT: 'zuschnitt-fehlt',
    SPERRGUT_FEHLT: 'sperrgut-fehlt',
    SPERRGUT_DOPPELT: 'sperrgut-doppelt'
  };

  var TEXT = {};
  TEXT[GRUND.GRUPPE_OHNE_HAUPT] =
    'Dieser Service gehört zu einem Artikel, der nicht mehr im Warenkorb ist – bitte entfernen';
  TEXT[GRUND.OHNE_MASS] =
    'Dieser Artikel braucht eine Maßangabe – bitte über die Produktseite konfigurieren';
  TEXT[GRUND.SERVICE_OHNE_GRUPPE] = TEXT[GRUND.OHNE_MASS];
  TEXT[GRUND.ZUSCHNITT_FEHLT] =
    'Der Zuschnitt von der Rolle fehlt – bitte Teppich entfernen und neu konfigurieren';
  TEXT[GRUND.SPERRGUT_FEHLT] =
    'Für diese Treppenkante fehlt der Sperrgut-Versand – bitte entfernen und über die Produktseite neu in den Warenkorb legen';
  TEXT[GRUND.SPERRGUT_DOPPELT] =
    'Der Sperrgut-Versand steht mehrfach im Warenkorb – bitte eine Treppenkante entfernen und neu in den Warenkorb legen';

  // Treppenkanten ueber der Paketlaenge (blocks/tp-laengen-zuschnitt): die
  // Zeile nennt in _Sperrgut die Variante des Zuschlags. Er steht nur einmal im
  // Warenkorb; fehlt er (z. B. mit der anderen Gruppe entfernt), ist die Zeile
  // eine Waise; steht er mehrfach (zwei Tabs gleichzeitig), ebenso.
  // Liquid-Seite: snippets/tp-cart-laengenware.liquid. Gibt die Anzahl zurueck
  // (null ohne _Sperrgut).
  function sperrgutAnzahl(zeile, zeilen) {
    var id = prop(zeile, '_Sperrgut');
    if (!id) return null;
    var n = 0;
    (zeilen || []).forEach(function (z) {
      var v = z && (z.variant_id != null ? z.variant_id : z.variantId);
      if (v != null && String(v) === id) n += Number(z.quantity) || 0;
    });
    return n;
  }

  // Gemeinsamer Rollenbestand (Einfass-Konfigurator mit Zuschnitt-Bundle):
  // Die Hauptzeile nennt in _Rollenzuschnitt, wie viel Rolle (cm) ihr Zuschnitt
  // braucht; die Bundle-Zeile (0,57 EUR) derselben _Gruppe traegt "Rollenzuschnitt"
  // ("200 cm"). Fehlt sie oder ist sie kleiner, bucht der Checkout zu wenig
  // Bestand ab - die Hauptzeile wird dann wie eine Waise behandelt.
  function zentimeter(text) {
    var n = parseInt(String(text == null ? '' : text).replace(/[^0-9]/g, ''), 10);
    return n > 0 ? n : 0;
  }

  function zuschnittFehlt(zeile, zeilen) {
    var bedarf = zentimeter(prop(zeile, '_Rollenzuschnitt'));
    if (!bedarf) return false;
    var g = gruppe(zeile);
    var gedeckt = 0;
    (zeilen || []).forEach(function (z) {
      if (z === zeile || !g || gruppe(z) !== g) return;
      var cm = zentimeter(prop(z, 'Rollenzuschnitt'));
      if (cm) gedeckt += cm * (Number(z.quantity) || 0);
    });
    // Ein Teppich je Gruppe: die Menge der Hauptzeile ist Flaeche, keine Stueckzahl.
    return gedeckt < bedarf;
  }

  function props(zeile) {
    return (zeile && zeile.properties) || {};
  }

  function prop(zeile, key) {
    var v = props(zeile)[key];
    if (v == null) return '';
    return String(v).trim();
  }

  function hatProp(zeile, key) {
    return prop(zeile, key) !== '';
  }

  function gruppe(zeile) {
    return prop(zeile, '_Gruppe');
  }

  function istFlaechenware(zeile) {
    return !!(zeile && (zeile.preisPro001Qm === true || zeile.preisPro001Qm === 'true'));
  }

  function istLaengenware(zeile) {
    return !!(zeile && (zeile.preisPro001Lfm === true || zeile.preisPro001Lfm === 'true'));
  }

  function istWunschmass(zeile) {
    var opts = (zeile && zeile.optionen) || [];
    for (var i = 0; i < opts.length; i++) {
      if (WUNSCH.test(String(opts[i] == null ? '' : opts[i]).trim())) return true;
    }
    return false;
  }

  // Service-Zeile: haengt an einem anderen Artikel (Kettelservice, Fussleiste,
  // Haftunterlage, Holzleiste). Erkannt an "Zu ..." - oder an "Kante umlaufend" ohne
  // eigene Masse (die Teppich-Hauptzeile traegt "Maße" dazu).
  function istServiceTyp(zeile) {
    return SERVICE_TYP.test(String(zeile && zeile.typ != null ? zeile.typ : '').trim());
  }

  function istService(zeile) {
    for (var i = 0; i < SERVICE_KEYS.length; i++) {
      if (hatProp(zeile, SERVICE_KEYS[i])) return true;
    }
    if (hatProp(zeile, 'Kante umlaufend') && !hatProp(zeile, 'Maße')) return true;
    return istServiceTyp(zeile);
  }

  function istBerechnet(zeile) {
    if (!zeile) return false;
    if (gruppe(zeile)) return true;
    if (ART_WERTE.test(prop(zeile, 'Art'))) return true;
    if (hatProp(zeile, 'Gewünschte Länge')) return true;
    if (istFlaechenware(zeile)) return true;
    if (istService(zeile)) return true;
    if (hatProp(zeile, 'Kante umlaufend')) return true;
    if (istWunschmass(zeile)) return true;
    return false;
  }

  function hatMass(zeile) {
    for (var i = 0; i < MASS_KEYS.length; i++) {
      if (hatProp(zeile, MASS_KEYS[i])) return true;
    }
    return false;
  }

  function flaechenText(zeile) {
    for (var i = 0; i < FLAECHE_KEYS.length; i++) {
      var v = prop(zeile, FLAECHE_KEYS[i]);
      if (v) return v;
    }
    return '';
  }

  // Menge in Kundeneinheit, aus den Properties abgeleitet. Kein Preis.
  // Fallback ist die Stueckzahl, damit nie eine Zeile ohne Mengenangabe steht.
  function kundeneinheit(zeile) {
    if (!zeile) return '';
    var fl = flaechenText(zeile);
    if (fl) {
      // Rollenrechner ohne preis_pro_001_qm: Menge = ganze m2, die Property
      // nennt EIN Stueck. Dasselbe Mass zweimal im Warenkorb fasst Shopify zu
      // einer Zeile zusammen - dann "2 × 16,00 m²", sonst die echte Menge.
      var proStueck = prop(zeile, 'Fläche (aufgerundet)');
      if (proStueck && !istFlaechenware(zeile)) {
        var einzeln = Math.round(parseFloat(proStueck.replace('m²', '').replace(/\./g, '').replace(',', '.').trim()) * 100);
        var menge = (Number(zeile.quantity) || 0) * 100;
        if (einzeln > 0 && menge !== einzeln) {
          fl = (menge > einzeln && menge % einzeln === 0)
            ? (menge / einzeln) + ' × ' + fl
            : String(zeile.quantity) + ',00 m²';
        }
      }
      return hatProp(zeile, 'Mindestpreis') ? fl + ' (Mindestpreis)' : fl;
    }
    // Laengenware: "10 × 95 cm" statt der Menge 950 (cm)
    var stueckLaenge = prop(zeile, 'Länge je Stück');
    if (stueckLaenge) {
      var anzahl = prop(zeile, 'Anzahl').replace('Stück', '').trim() || '1';
      return anzahl + ' × ' + stueckLaenge;
    }
    if (istService(zeile)) {
      if (hatProp(zeile, 'Zu Bodenbelag')) return String(zeile.quantity) + (zeile.quantity === 1 ? ' Leiste' : ' Leisten');
      var kante = prop(zeile, 'Kante umlaufend');
      if (kante) return kante + ' Kettelkante';
      var laenge = prop(zeile, 'Länge');
      if (laenge && hatProp(zeile, 'Höhe')) return laenge + ' Fußleiste';
      if (laenge) return laenge;
      var rolle = prop(zeile, 'Rollenzuschnitt');
      if (rolle) return rolle + ' von der Rolle';
      var bahnen = prop(zeile, 'Bahnen');
      if (bahnen) return String(zeile.quantity) + ' lfm (' + bahnen + (bahnen === '1' ? ' Bahn' : ' Bahnen') + ')';
    }
    var kante2 = prop(zeile, 'Kante umlaufend');
    if (kante2) return kante2;
    var q = zeile.quantity == null ? '' : String(zeile.quantity);
    return q ? q + ' Stück' : '';
  }

  // Gruppen: { kennung: { haupt: zeile|null, mitglieder: [zeile] } }
  function gruppen(zeilen) {
    var out = {};
    (zeilen || []).forEach(function (z) {
      var g = gruppe(z);
      if (!g) return;
      if (!out[g]) out[g] = { haupt: null, mitglieder: [] };
      out[g].mitglieder.push(z);
      if (!istService(z) && !out[g].haupt) out[g].haupt = z;
    });
    return out;
  }

  function hauptzeile(zeile, zeilen) {
    var g = gruppe(zeile);
    if (!g) return null;
    var grp = gruppen(zeilen)[g];
    return grp ? grp.haupt : null;
  }

  // Hinweis fuer eine Nebenzeile: zu welcher Hauptzeile sie gehoert.
  function gruppenHinweis(zeile, zeilen) {
    if (!gruppe(zeile) || !istService(zeile)) return '';
    var h = hauptzeile(zeile, zeilen);
    if (!h) return '';
    var t = h.titel || prop(zeile, 'Zu Teppich') || prop(zeile, 'Zu Teppichboden') || prop(zeile, 'Zu Bodenbelag');
    return 'Gehört zu ' + t + '; wird gemeinsam entfernt';
  }

  // Waisen: Zeilen, die nicht bestellt werden duerfen. Liefert je Zeile
  // {index, key, grund} oder nichts.
  function waisen(zeilen) {
    var out = [];
    var grps = gruppen(zeilen);
    (zeilen || []).forEach(function (z, i) {
      var grund = null;
      var g = gruppe(z);
      if (g && istService(z) && !grps[g].haupt) {
        grund = GRUND.GRUPPE_OHNE_HAUPT;
      } else if (!g && istService(z)) {
        grund = GRUND.SERVICE_OHNE_GRUPPE;
      } else if ((istFlaechenware(z) || istWunschmass(z)) && !hatMass(z)) {
        grund = GRUND.OHNE_MASS;
      } else if (istLaengenware(z) && !hatProp(z, 'Länge je Stück')) {
        grund = GRUND.OHNE_MASS;
      } else if (zuschnittFehlt(z, zeilen)) {
        grund = GRUND.ZUSCHNITT_FEHLT;
      } else if (sperrgutAnzahl(z, zeilen) === 0) {
        grund = GRUND.SPERRGUT_FEHLT;
      } else if (sperrgutAnzahl(z, zeilen) > 1) {
        grund = GRUND.SPERRGUT_DOPPELT;
      }
      if (grund) out.push({ index: i, key: z.key, grund: grund, text: TEXT[grund] });
    });
    return out;
  }

  function checkoutGesperrt(zeilen) {
    return waisen(zeilen).length > 0;
  }

  // Alle Keys, die beim Loeschen einer Zeile mitgehen (die Zeile selbst
  // eingeschlossen). Ohne Gruppe nur die Zeile selbst.
  function zuEntfernen(zeile, zeilen) {
    var g = gruppe(zeile);
    if (!g) return zeile && zeile.key ? [zeile.key] : [];
    var keys = [];
    (zeilen || []).forEach(function (z) {
      if (gruppe(z) === g && z.key && keys.indexOf(z.key) < 0) keys.push(z.key);
    });
    if (zeile && zeile.key && keys.indexOf(zeile.key) < 0) keys.push(zeile.key);
    return keys;
  }

  // /cart/update.js-Body fuer eine Gruppe.
  function updateBody(keys) {
    var updates = {};
    (keys || []).forEach(function (k) { updates[k] = 0; });
    return { updates: updates };
  }

  root.TPCartGruppen = {
    GRUND: GRUND,
    TEXT: TEXT,
    gruppe: gruppe,
    istFlaechenware: istFlaechenware,
    istLaengenware: istLaengenware,
    istWunschmass: istWunschmass,
    istServiceTyp: istServiceTyp,
    istService: istService,
    istBerechnet: istBerechnet,
    hatMass: hatMass,
    kundeneinheit: kundeneinheit,
    gruppen: gruppen,
    hauptzeile: hauptzeile,
    gruppenHinweis: gruppenHinweis,
    waisen: waisen,
    zuschnittFehlt: zuschnittFehlt,
    checkoutGesperrt: checkoutGesperrt,
    zuEntfernen: zuEntfernen,
    updateBody: updateBody
  };
})(typeof window !== 'undefined' ? window : globalThis);
